import { render, staticRenderFns } from "./AfterPlanAlreadySubscribed.vue?vue&type=template&id=531bfdf2&scoped=true&"
import script from "./AfterPlanAlreadySubscribed.vue?vue&type=script&lang=ts&"
export * from "./AfterPlanAlreadySubscribed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531bfdf2",
  null
  
)

export default component.exports